import { render } from "./wlbj.vue?vue&type=template&id=ede96504&scoped=true"
import script from "./wlbj.vue?vue&type=script&lang=js"
export * from "./wlbj.vue?vue&type=script&lang=js"

import "./wlbj.vue?vue&type=style&index=0&id=ede96504&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede96504"]])

export default __exports__